import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Avatar, Button, Stack, TextField, Typography} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React, {useEffect, useState} from "react";
import {set, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {config} from "../../../constant";
import DialogImageUpload from "../dialog/DialogImageUpload";

export default function DialogEditPerson({open, onClose, person, setPerson}) {
    const [imageDialogOpen, setImageDialogOpen] = useState(false);
    const [personId, setPersonId] = useState(false);

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required("Prénom obligatoire"),
        email: Yup.string().email("Format incorrect")
    });

    const {register, reset, control, handleSubmit, formState: {errors}} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: person ? {
            id: person.id,
            firstName: person.firstName,
            lastName: person.lastName,
            email: person.email
        } : {
            id: null,
            firstName: '',
            lastName: '',
            email: ''
        }
    });

    const onSubmit = (data) => {
        const requestOptions = {
            method: person ? 'PUT' : 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        };
        fetch(`${config.BASE_URL}/people`, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (person) {
                    // En édition, on ferma le dialog après la sauvegarde
                    onClose(true);
                } else {
                    // En création, on ouvre le dialog image
                    setPersonId(data.id);
                    setImageDialogOpen(true);
                }
            })
            .catch((error) => {
                console.error('Erreur dans la création ou mise à jour d\'une personne', error);
            });
    };

    return (
        <>
            <Dialog open={open} onClose={() => onClose(false)} maxWidth={'lg'}>
                <DialogTitle>
                    <Stack direction="row" alignItems="center" spacing={2} sx={{justifyContent: 'space-between'}}>
                        Personne
                        {person && (
                            <Avatar
                                alt={person.firstName}
                                src={person.avatar ? `data:${person.avatar.contentType};base64,${person.avatar.data}` : '/assets/images/avatars/avatar_1.jpg'}
                                onClick={() => {
                                    setPersonId(person.id);
                                    setImageDialogOpen(true);
                                }}
                                sx={{cursor: 'pointer'}}
                            />
                        )}
                    </Stack>
                </DialogTitle>
                <DialogContent>
                    <form id="personForm" onSubmit={handleSubmit(onSubmit)}>
                        <TextField
                            margin="dense"
                            id="firstName"
                            name="firstName"
                            label="Prénom"
                            fullWidth
                            variant="standard"
                            {...register("firstName")}
                            error={!!errors.firstName}
                        />
                        <Typography variant="inherit" color="textSecondary">{errors.firstName?.message}</Typography>

                        <TextField
                            margin="dense"
                            id="lastName"
                            name="lastName"
                            label="Nom"
                            fullWidth
                            variant="standard"
                            {...register("lastName")}
                            error={!!errors.lastName}
                        />
                        <Typography variant="inherit" color="textSecondary">{errors.lastName?.message}</Typography>

                        <TextField
                            margin="dense"
                            id="email"
                            name="email"
                            label="E-mail"
                            fullWidth
                            variant="standard"
                            {...register("email")}
                            error={!!errors.email}
                        />
                        <Typography variant="inherit" color="textSecondary">{errors.email?.message}</Typography>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button type="submit" form="personForm">OK</Button>
                    <Button onClick={() => onClose(false)}>Annuler</Button>
                </DialogActions>
            </Dialog>

            {imageDialogOpen && (
                <DialogImageUpload
                    open={imageDialogOpen}
                    onClose={image => {
                        setImageDialogOpen(false);
                        if (person) {
                            // En édition, le dialog de la personne est toujours ouvert, donc on met à jour l'avatar
                            if (image) {
                                setPerson(values => ({...values, 'avatar': image}));
                            }
                        } else {
                            // En création, on a ouvert la popin image après la création de la personne, donc on ferme
                            onClose(true);
                        }
                    }}
                    id={personId}>
                </DialogImageUpload>
            )}
        </>
    );
}
